var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-height overflow-hidden"},[_c('Header'),_c('div',{staticClass:"main flex-start-justify"},[_c('div',{staticClass:"step-content box-shadow-base"},[_c('h1',{staticClass:"top"},[_vm._v("找回密码")]),_c('div',{staticClass:"step-detail"},[_c('find-password',{attrs:{"userType":_vm.userType}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }